import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-southwestairlines',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Southwest Airlines icon</title><path d="M22.163 2.419C21.038 1.219 19.35.58 17.437.58c-2.062 0-3.637.675-4.725 1.275 2.063 1.163 6.526 3.75 11.175 7.163.075-.45.113-.938.113-1.388-.038-2.175-.675-4.012-1.837-5.212zm1.35 8.212C18.186 6.244 15 4.031 11.55 1.97 10.612 1.406 8.775.58 6.675.58 4.688.581 3 1.22 1.837 2.42 1.087 3.206.563 4.18.262 5.38 3 7.294 10.462 12.656 18 18.581c2.512-2.362 4.613-5.1 5.512-7.95zM0 7.781c0 6.15 6.487 11.85 12 15.638 1.575-1.088 3.225-2.325 4.8-3.713A736.871 736.871 0 0 0 .15 6.131C.038 6.62 0 7.181 0 7.781Z"/></svg>`,
    styles: []
})
export class SimpleIconsSouthwestairlinesComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#304CB2';
    @Input() className: string = 'simple-icons-southwestairlines'
    constructor() {}
    ngOnInit(): void {}
}
